<template>
  <v-container
    id="comercial-form"
    fluid
    tag="section"
    class="px-3 pt-0"
    style="margin-top: 1rem"
  >
    <v-row>
      <v-col
        cols="12"
        lg="12"
        class="px-1"
      >
        <v-container
          style="margin-left: -0.3rem; margin-right: 3rem;"
        >
          <dashboard-filtro-mais-vida
            :primeiro="enablePrimeiroDia"
            :ultimo="enableUltimoDia"
            :empresas="enableEmpresa"
            :url="link"
            :cidades="enableCidades"
            :vendedores="enableVendedores"
            :redes="enableRedes"
            :areas="enableAreas"
            :btn1="enableBtn"
            :btn2="disableBtn"
            :enable-datas="enableDatas"
            :receitas="enableReceita"
            :segmentos="enableSegmento"
            :categorias="enableCategoria"
            :promotores="enablePromotor"
          />
          <v-container>
            <v-row
              v-if="enableBtnPrint"
              id="btnPrint"
            >
              <v-btn
                class="col-4 col-sm-3 col-md-1 col-lg-1"
                small
                :color="corPrimaria"
                dark
                :loading="imprimindo"
                @click="imprimir()"
              >
                <v-icon>
                  mdi-printer
                </v-icon>
                Imprimir
                <template v-slot:loader>
                  <span>Imprimindo...</span>
                </template>
              </v-btn>
            </v-row>
          </v-container>
          <v-row>
            <v-col
              cols="12"
              sm="12"
              md="12"
              lg="12"
            >
              <v-card
                id="cardDashbord"
                class="mx-auto"
                outlined
              >
                <div class="card-header-dashbord">
                  <v-row>
                    <v-col
                      cols="12"
                      sm="10"
                      md="10"
                      lg="10"
                      class="d-flex flex-wrap"
                    >
                      Mix Cliente
                    </v-col>
                    <v-col
                      cols="12"
                      sm="2"
                      md="2"
                      lg="2"
                      class="d-flex justify-end"
                    >
                      <v-tooltip
                        top
                        max-width="400"
                        width="400"
                      >
                        <template
                          v-slot:activator="{ on, attrs }"
                        >
                          <v-icon
                            id="iconInformationClientesParcipantes"
                            class="text-left"
                            v-bind="attrs"
                            v-on="on"
                            @mouseover="enableTexto('233')"
                          >
                            mdi-information-outline
                          </v-icon>
                        </template>
                        <div
                          v-if="!carregandoTooltip"
                          v-html="textoOrientacao"
                        />
                      </v-tooltip>
                    </v-col>
                  </v-row>
                </div>
                <v-card-actions>
                  <v-row>
                    <v-col
                      cols="12"
                      sm="12"
                      md="12"
                      lg="12"
                    >
                      <dashboard-mix-cliente />
                    </v-col>
                  </v-row>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-col>
    </v-row>
    <dashboard-core-snackbar
      v-model="snackbar.visible"
      :visible="snackbar.visible"
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      :message="snackbar.message"
    />
  </v-container>
</template>

<script>
  import utils from '../../../../services/utils'
  import Permissao from '../../../../services/menu'
  import eventEmit from '../../components/core/EventoEmit'
  import JSPDF from 'jspdf'
  import 'jspdf-autotable'

  export default {
    name: 'PageMaisVida08',
    emits: ['updateFormMaisVida', 'atualizarTexto'],
    components: {
      DashboardCoreSnackbar: () => import('../../components/core/Snackbar'),
      DashboardFiltroMaisVida: () => import('../../components/core/FiltrosMaisVida'),
      DashboardMixCliente: () => import('../../components/comercial/MixCliente'),
    },
    mixins: [utils],
    data: () => ({
      appOnline: navigator.onLine,
      corPrimaria: localStorage.corPrimaria,
      usuarioIdentificado: false,
      snackbar: {
        visible: false,
        color: 'success',
        direction: 'top center',
        message: 'My timeout is set to 3000.',
        timeout: 3000,
      },
      metaMensal: 0,
      dataInicial: (new Date(new Date().getFullYear(), new Date().getMonth(), 1)).toISOString().substr(0, 10),
      dataFinal: (new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).toISOString().substr(0, 10),
      dateFormatted: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      select: [],
      empresa: [],
      link: window.location.href,
      clientes: [],
      cidades: [],
      areas: [],
      vendedores: [],
      redes: [],
      produtos: [],
      receita: [],
      segmento: [],
      categoria: [],
      promotor: [],
      paginaEnable: true,
      enablePrimeiroDia: true,
      enableUltimoDia: true,
      enableEmpresa: true,
      enableClientes: false,
      enableCidades: true,
      enableAreas: true,
      enableVendedores: true,
      enableRedes: true,
      enableProdutos: false,
      enableLinhas: false,
      enableReceita: true,
      enableSegmento: true,
      clienteTotal: 0,
      enableBtn: true,
      disableBtn: false,
      enableDatas: true,
      enableCategoria: true,
      enablePromotor: true,
      codigo: 0,
      orientacao: [],
      textoMixCliente: '',
      codigoIds: ['233'],
      dynamicPaddingMixCliente: '',
      imprimindo: false,
      enableBtnPrint: false,
      headersVenda: [
        { text: 'Quantidade de Clientes Faturados', value: 'cliente', align: 'left', class: 'black--text title' },
        { text: 'Faturamento', value: 'faturamento', align: 'right', class: 'black--text title' },
        { text: 'Média Faturamento', value: 'media', align: 'right', class: 'black--text title' },
      ],
      headersSemMovimento: [
        { text: 'Clientes Não Compraram', value: 'cliente', align: 'left', class: 'black--text title' },
        { text: 'Vendedor Responsável', value: 'vendedor', align: 'lef', class: 'black--text title' },
        { text: 'Faturamento', value: 'faturamento', align: 'right', class: 'black--text title' },
        { text: 'Área Comercial', value: 'area', align: 'left', class: 'black--text title' },
      ],
      tableVendas: [],
      tableSemMovimento: [],
      produto: '',
      totalClientes: 0,
      textoOrientacao: '',
      carregandoTooltip: false,
      codigoAtual: null,
    }),

    created () {
      eventEmit.$on('update-dados-mais-vida', this.handleUpdateDados)

      eventEmit.$on('set-dados-print-mix-cliente', this.handleDadosPrint)
    },

    beforeDestroy () {
      eventEmit.$off('update-dados-mais-vida', this.handleUpdateDados)

      eventEmit.$off('set-dados-print-mix-cliente', this.handleDadosPrint)

      window.removeEventListener('resize', this.updateDynamicPadding)
    },

    mounted () {
      if (localStorage.tokencontrato) {
        eventEmit.$emit('atualizar_texto', 'Mix Cliente')

        this.updateDynamicPadding()

        window.addEventListener('resize', this.updateDynamicPadding)

        this.usuarioIdentificado = true
      } else {
        this.usuarioIdentificado = false
        this.$router.push('/login')
      }
    },

    methods: {
      updateDynamicPadding () {
        if (window.innerWidth > 1800) {
          this.dynamicPaddingMixCliente = 'padding-right: 117rem !important'
        } else if (window.innerWidth > 1380 && window.innerWidth <= 1800) {
          this.dynamicPaddingMixCliente = 'padding-right: 75rem !important'
        } else if (window.innerWidth > 380 && window.innerWidth < 680) {
          this.dynamicPaddingMixCliente = 'padding-right: 15.5rem !important'
        } else if (window.innerWidth > 681 && window.innerWidth < 1000) {
          this.dynamicPaddingMixCliente = 'padding-right: 40rem !important'
        } else {
          this.dynamicPaddingMixCliente = 'padding-right: 67rem !important'
        }
      },

      handleUpdateDados (dataInicial, dataFinal, empresaSelect, cidadeSelect, areaSelect, redeSelect, vendedorSelect, produtoSelect, linhaSelect, clienteSelect, caixaSelect, selectTipoDevolucao, selectMotivoDevolucao, primeiroDia2, date2, select1, cidadeSelect1, areaSelect1, redeSelect1, vendedorSelect1, produtoSelect1, linhaSelect1, clienteSelect1, caixaSelect1, selectReceita, segmento, segmento1, supervisor, supervisor2, tipoBrinde, motivoBrinde, categoria, promotor) {
        this.dataInicial = dataInicial
        this.dataFinal = dataFinal
        this.select = empresaSelect
        this.cidades = cidadeSelect
        this.areas = areaSelect
        this.redes = redeSelect
        this.vendedores = vendedorSelect
        this.produtos = produtoSelect
        this.clientes = clienteSelect
        this.receita = selectReceita
        this.segmento = segmento
        this.categoria = categoria
        this.promotor = promotor

        localStorage.setItem('updateDadosFiltros', true)
        localStorage.setItem('dataInicial', this.dataInicial)
        localStorage.setItem('dataFinal', this.dataFinal)

        this.updateDados()
      },

      handleDadosPrint (produto, dadosSemMovimento, dadosClientesFaturados, totalClientes) {
        this.produto = produto
        this.tableVendas = dadosClientesFaturados
        this.tableSemMovimento = dadosSemMovimento
        this.totalClientes = totalClientes

        this.enableBtnPrint = true
      },

      updateDados () {
        eventEmit.$emit('update-form-mais-vida', this.dataInicial, this.dataFinal, this.select, this.cidades, this.areas, this.vendedores, this.redes, this.produtos, this.linhas, this.clientes, this.receita, this.segmento, this.categoria, this.promotor)
      },

      async enableTexto (value) {
        if (this.codigoAtual === value && this.textoOrientacao) return

        this.codigoAtual = value
        this.carregandoTooltip = true
        this.textoOrientacao = ''

        try {
          const resposta = await Permissao.showOrientacaoIndicador(localStorage.username, localStorage.tokencontrato, value)

          if (resposta.data.status) {
            this.textoOrientacao = resposta.data.orientacao
            this.codigo = value
          }
        } catch (e) {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        } finally {
          this.carregandoTooltip = false
        }
      },

      async imprimir () {
        try {
          this.imprimindo = true

          await setTimeout(() => {
            this.print()
          }, 2000)
        } catch (error) {
          console.error('Erro ao imprimir:', error)
        }
      },

      async print () {
        try {
          const pdf = new JSPDF('landscape', 'mm')

          let posYFiltros = 10

          const title = 'Filtros selecionados'
          pdf.text(title, 105, posYFiltros)

          const dataInicial = this.dataInicial.substr(8) + '/' + this.dataInicial.substr(5, 2) + '/' + this.dataInicial.substr(0, 4)
          const ultimoDia = this.dataFinal.substr(8) + '/' + this.dataFinal.substr(5, 2) + '/' + this.dataFinal.substr(0, 4)

          const datas = 'Data inicial: ' + dataInicial + ' - Data final: ' + ultimoDia
          posYFiltros += 10
          pdf.setFontSize(10)
          pdf.text(datas, 15, posYFiltros)

          posYFiltros += 10

          const adicionarFiltros = async (pdf, posYFiltros, titulo, dados) => {
            if (dados.length > 0) {
              let texto = titulo + ' '

              for (let i = 0; i < dados.length; i++) {
                texto += dados[i] + ', '
              }

              texto = texto.slice(0, -2)

              const linhas = this.quebrarString(texto, 135)

              linhas.forEach((linha, index) => {
                if (posYFiltros === 200) {
                  pdf.addPage()

                  posYFiltros = 10

                  pdf.text(linha, 15, posYFiltros)

                  posYFiltros += 10
                } else {
                  pdf.text(linha, 15, posYFiltros)

                  posYFiltros += 10
                }
              })
            }

            return posYFiltros
          }

          posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Empresa(s) Selecionada(s):', this.select.map(e => e.nomeExibicao))
          posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Cidade(s) Selecionada(s):', this.cidades.map(e => e.cidade))
          posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Área(s) Selecionada(s):', this.areas.map(a => a.area))
          posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Vendedor(es) Selecionado(s):', this.vendedores.map(v => v.vendedor))
          posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Rede(s) Selecionada(s):', this.redes.map(r => r.rede))
          posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Receita(s) Selecionada(s):', this.receita.map(re => re.nome))
          posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Segmento(s) Selecionado(s):', this.segmento.map(se => se.segmento))

          if (posYFiltros > 100) {
            pdf.addPage()

            posYFiltros = 10
          }

          const produtoImpresso = 'Produto selecionado: ' + this.produto
          pdf.text(produtoImpresso, 15, posYFiltros)
          posYFiltros += 10 + pdf.getTextDimensions(produtoImpresso).h

          const tableVendas = this.tableVendas.map(item => [item.cliente, item.faturamento, item.media])
          pdf.autoTable({
            head: [this.headersVenda.map(header => ({ content: header.text, styles: { fontSize: 10, textColor: [0, 0, 0] } }))],
            body: tableVendas.map(row => row.map(cell => ({ content: cell, styles: { fontSize: 8, textColor: [0, 0, 0] } }))),
            startY: posYFiltros,
            styles: { fontSize: 10 },
          })

          const endY = pdf.lastAutoTable.finalY
          const alturaTabela = endY - posYFiltros

          posYFiltros += alturaTabela + 10

          const tableWidth = pdf.internal.pageSize.getWidth() - 28

          const textTotalCliente = 'Quantidade Clientes: ' + this.totalClientes
          const textHeight = pdf.getTextDimensions(textTotalCliente).h
          const padding = 2
          const rectHeight = textHeight + 2 * padding

          pdf.setFillColor('#2980ba')
          pdf.rect(14, posYFiltros, tableWidth, rectHeight, 'F')

          pdf.setFont('helvetica', 'bold')
          pdf.setTextColor(0, 0, 0)
          pdf.text(textTotalCliente, 16, posYFiltros + (textHeight + 2))

          posYFiltros += rectHeight

          const tableSemMovimento = this.tableSemMovimento.map(item => [item.cliente, item.vendedor, item.faturamento.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }), item.area])
          pdf.autoTable({
            head: [this.headersSemMovimento.map(header => ({ content: header.text, styles: { fontSize: 10, textColor: [0, 0, 0] } }))],
            body: tableSemMovimento.map(row => row.map((cell, index) => {
              const isFaturamentoColumn = index === 2
              return {
                content: cell,
                styles: {
                  fontSize: 8,
                  textColor: [0, 0, 0],
                  halign: isFaturamentoColumn ? 'right' : 'left',
                },
              }
            })),
            startY: posYFiltros,
            styles: { fontSize: 10 },
          })

          pdf.save('relatorio_mix_cliente.pdf')
        } catch (error) {
          console.error('Erro ao gerar PDF:', error)
        } finally {
          this.produto = ''
          this.tableVendas = []
          this.tableSemMovimento = []
          this.imprimindo = false
        }
      },

      quebrarString (str, limiteCaracteresPorLinha) {
        const palavras = str.split(' ')
        let linhaAtual = ''
        const linhas = []

        palavras.forEach(palavra => {
          if ((linhaAtual + palavra).length <= limiteCaracteresPorLinha) {
            linhaAtual += palavra + ' '
          } else {
            linhas.push(linhaAtual.trim())
            linhaAtual = palavra + ' '
          }
        })

        if (linhaAtual !== '') {
          linhas.push(linhaAtual.trim())
        }

        return linhas
      },

      showSnackbar (color, timeout, message) {
        this.snackbar.message = message
        this.snackbar.color = color
        this.snackbar.visible = true
        this.snackbar.timeout = timeout
      },
    },
  }
</script>

<style scoped>
  #cardDashbord {
    border-radius: 14px;
    border: 1px solid rgba(0,0,0,0.05);
    box-shadow:
      0 2px 4px rgba(0,0,0,0.08),
      0 6px 12px rgba(0,0,0,0.06),
      0 12px 24px rgba(0,0,0,0.04);
    transition: all 0.25s ease;
    transform: translateY(-3px);
    box-shadow:
      0 4px 8px rgba(0,0,0,0.10),
      0 12px 22px rgba(0,0,0,0.09),
      0 20px 32px rgba(0,0,0,0.06);
  }

  .card-header-dashbord {
    background-color: #ffffff;
    padding: 14px 18px;
    font-weight: 600;
    font-size: 14px;
    color: black;
    border-bottom: 1px solid #b7b1b1;
    border-radius: 14px 14px 0 0;
  }

  @media screen
  and (min-device-width : 320px)
  and (max-device-width : 560px) {

  }

  @media screen
  and (min-width : 481px)
  and (max-width : 960px)
  and (-webkit-min-device-pixel-ratio: 1) {

  }

  @media screen
  and (min-width: 1380px) {

  }
</style>

<style lang="sass">
  .container
    max-width: 100% !important

  #iconInformationBaseAtendimento
    margin: 0 0 0 2.8rem

  .highlighted-item
    background-color: #2863af
    padding: 16px
    color: white
    margin: -1rem 0 0 0

  #listItemMixCliente
    margin: -2rem 0 0 -1rem

</style>
